module.exports = __webpack_public_path__ + "static/media/supply_track.f459b7f1.png";